export default {
  acceptdButton: 'Accept',
  rejectButton: 'Decline',
  termsAndConditionsLabel: 'I have read and accept the terms and conditions'
}
